import { render, staticRenderFns } from "./sms-list.vue?vue&type=template&id=d67e1d38&scoped=true"
import script from "./sms-list.vue?vue&type=script&lang=js"
export * from "./sms-list.vue?vue&type=script&lang=js"
import style0 from "./sms-list.vue?vue&type=style&index=0&id=d67e1d38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67e1d38",
  null
  
)

export default component.exports